import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ConfigAndConnectionTest } from "./ConfigAndConnectionTest";
import { InfradigitalConfigDebugger } from "./InfradigitalConfigDebugger";
import { BillComponentDebugger } from "./BillComponentDebugger";
import { InfradigitalDirectTest } from "./InfradigitalDirectTest";
import { EmailTester } from "./EmailTester";
import { BillStatusUpdate } from "./BillStatusUpdate";
import { DataAggregatorTest } from "./DataAggregatorTest";
import { RenewalSystemTest } from "./RenewalSystemTest";
import { SubscriptionStatusCheck } from "./SubscriptionStatusCheck";
import { ApiTestingTips } from "./components/ApiTestingTips";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

export function PaymentIntegrationTest() {
  return (
    <div className="container py-10">
      <h1 className="text-2xl font-bold mb-4 text-teal-700">Payment Integration Tests</h1>
      
      <Alert className="mb-6 bg-amber-50 border-amber-200">
        <Info className="h-4 w-4 text-amber-500" />
        <AlertTitle>Integration Update</AlertTitle>
        <AlertDescription>
          The create-bill-component function has been updated to use all required authentication headers.
          For best results, continue to use the original Infradigital function for production use.
        </AlertDescription>
      </Alert>
      
      <div className="grid gap-8">
        {/* Add the new component first */}
        <ConfigAndConnectionTest />
        
        {/* Keep existing components */}
        <InfradigitalConfigDebugger />
        <BillComponentDebugger />
        <InfradigitalDirectTest />
        <EmailTester />
        <BillStatusUpdate />
        <DataAggregatorTest />
        <RenewalSystemTest />
        <SubscriptionStatusCheck />
        <ApiTestingTips />
      </div>
    </div>
  );
}
